import { NgModule } from '@angular/core';
import { ComponentsModule } from './lib/components/components-api';

@NgModule({
  imports: [
    ComponentsModule
  ],
  exports: [
    ComponentsModule
  ]
})
export class AegLibModule {}